import Swiper from 'swiper';

const FeaturedPostSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.featured-post__carousel.swiper');
        if (!carousels.length) return;

        carousels.forEach((carousel) => {
            const slides = carousel.querySelectorAll('.swiper-slide');
            const desktopThreshold = parseInt(carousel.getAttribute('data-desktop-threshold') || '2', 10);
            const mq = window.matchMedia('(max-width: 1023px)');
            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');
            const pagination = carousel.querySelector('.featured-post__pagination');
            let swiper = null;
            const handlePrevClick = () => {
                if (swiper) {
                    swiper.slidePrev();
                }
            };
            const handleNextClick = () => {
                if (swiper) {
                    swiper.slideNext();
                }
            };

            const updateButtonStates = () => {
                if (!swiper || !prevButton || !nextButton) return;

                prevButton.disabled = swiper.isBeginning;
                nextButton.disabled = swiper.isEnd;
                prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
            };

            const enable = () => {
                if (swiper) return;

                swiper = new Swiper(carousel, {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    loop: false,
                    breakpoints: {
                        740: {
                            slidesPerView: 2,
                        },
                        1180: {
                            slidesPerView: 2,
                        }
                    }
                });

                if (prevButton && nextButton) {
                    prevButton.addEventListener('click', handlePrevClick);
                    nextButton.addEventListener('click', handleNextClick);
                    updateButtonStates();
                    swiper.on('slideChange', updateButtonStates);
                }

                if (pagination) {
                    pagination.hidden = slides.length <= desktopThreshold;
                }
            };

            const disable = () => {
                if (!swiper) return;
                swiper.destroy(true, true);
                swiper = null;

                if (pagination) {
                    pagination.hidden = true;
                }
            };

            const handleChange = () => {
                const shouldEnable = mq.matches ? slides.length > 1 : slides.length > desktopThreshold;

                if (shouldEnable) {
                    enable();
                } else {
                    disable();
                }
            };

            handleChange();

            if (mq.addEventListener) {
                mq.addEventListener('change', handleChange);
            } else {
                mq.addListener(handleChange);
            }
        });
    };

    return {
        init
    };
};

export default FeaturedPostSlider;
